import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getData } from "../../../../services/generalService";
import { TransactionConfigObj } from "../../../../utils/types";

const initialState: TransactionConfigObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getTransactionConfigData = createAsyncThunk(
  "config/getTransactionConfigDataDetails",
  async (url: string, thunkAPI) => {
    try {
      const data = await getData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const transactionConfigSlice = createSlice({
  name: "transactionConfig",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTransactionConfigData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTransactionConfigData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getTransactionConfigData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default transactionConfigSlice.reducer;
